import React from 'react';
import {
  Form,
  Label,
  Select,
} from '../../common/components/form';
import Button from '../../../ui/button/Button';

import { Localize } from '../../../locale/localization';

const TransactionsExportForm = (props) => {
  const {
    enabled,
    onSubmit,
    onCancel,
    onBlur,
    onInputChange,
    errors,
    touchedFields,
    isValid,
    channel,
    channels,
  } = props;

  const options = channels ? channels.map((op) => <option key={op._id} value={op._id}>{op.name}</option>) : null;
  
  return (
    <Form
      onSubmit={onSubmit}
      autoCorrect="off"
      autoComplete="off"
      noValidate
      spellCheck="false"
      onBlur={onBlur}
    >
      {channels && channels.length > 0 && (
        <Label label={Localize('channel')}>
          <Select
            value={channel}
            name="channel"
            error={errors['channel'] && touchedFields.indexOf('channel') > -1}
            errorMessage={errors['channel']}
            onChange={onInputChange}
          >
            <option key="_all_" value="_all_">{Localize('channel.all')}</option>
            {options}
          </Select>
        </Label>
      )}
      <footer>
        <Button onClick={onCancel}>{Localize('action.cancel')}</Button>
        <Button disabled={!isValid || !enabled} type="submit">Tulosta</Button>
      </footer>
    </Form>
  );
};

export default TransactionsExportForm;


// WEBPACK FOOTER //
// ./src/modules/transaction/components/TransactionsExportForm.js